import React from "react";
import { Grid, ListItemButton, ListItemText, Typography } from "@mui/material";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import VillaOutlinedIcon from "@mui/icons-material/VillaOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HouseOutlinedIcon from "@mui/icons-material/HouseOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Investor from "../assets/investor.png"
import "./components.css";

const ListItemButtonStack = (props) => {
  const handleAnswerChange = (value) => {
    props.onChange(props.questionKey, value);
  };

  const getIcon = (value) => {
    switch (value) {
      case "Primary Residence":
        return <CottageOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Second Home":
        return <VillaOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Investment Property":
        return <TrendingUpOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Single Family":
        return <HomeOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Town House":
        return <HouseOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Condo":
        return <HomeWorkOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Multi Family":
        return <ApartmentOutlinedIcon sx={{ fontSize: 50 }} />;
      case "Employed":
        return <img src={require('../assets/Employed.png')} alt="employed"  />
      case "Self Employed":
        return <img src={require('../assets/SelfEmployed.png')} alt="employed"  />
      case "Retired":
        return <img src={require('../assets/Retired.png')} alt="employed" />
      case "Yes":
        return <img src={require('../assets/yes.png')} alt="employed"  />
      case "No":
        return <img src={require('../assets/No.png')} alt="employed" />
      case "BrowsingHomes":
          return <img src={require('../assets/Browsing.png')} alt="employed"  />
      case "YettoFinalize":
        return <img src={require('../assets/YettoFinalize.png')} alt="employed"  />
      case "Signed":
        return <img src={require('../assets/Signed.png')} alt="employed"  />
      case "Investor":
        return <img src={Investor} style={{height:"80px"}} alt="investor" />
      default:
        return null;
    }
  };

  return (
      <Grid container spacing={3} justifyContent="flex-start" alignItems="center">
        {props.options.map((option) => (
            <Grid item xs={6} sm={6} md={6} key={option.value}>
              <ListItemButton
                  onClick={() => handleAnswerChange(option.value)}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: props.value === option.value ? '2px solid #00634a' : '2px solid #e0e0e0',
                    borderRadius: '12px',
                    backgroundColor: props.value === option.value ? '#f0f7f4' : '#ffffff',
                    color: props.value === option.value ? '#00634a' : '#333',
                    padding: '20px',
                    height: '150px',
                    textAlign: 'center',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease-in-out',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.border = '2px solid #00634a')}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.border =
                        props.value === option.value ? '2px solid #00634a' : '2px solid #e0e0e0';
                  }}
              >
                {getIcon(option.value)}
                <Typography
                    variant="body1"
                    sx={{
                      marginTop: '10px',
                      fontWeight: 'bold',
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '16px',
                    }}
                >
                  {option.text}
                </Typography>
              </ListItemButton>
            </Grid>
        ))}
      </Grid>
  );
};

export default ListItemButtonStack;
